import {defineMessages} from 'react-intl';

export default defineMessages({
	successMsg: {
		id: 'wishlist.popup.successMsg',
		defaultMessage: 'Added to Wishlist',
	},
	successRemovedMsg: {
		id: 'wishlist.popup.successRemovedMsg',
		defaultMessage: 'Removed from Wishlist',
	},
	successMovedFromCartMsg: {
		id: 'wishlist.popup.successMovedFromCartMsg',
		defaultMessage: 'Moved from Cart to Wishlist',
	},
	linkLabel: {
		id: 'wishlist.popup.linkLabel',
		defaultMessage: ' View',
	},
	guestMsg: {
		id: 'wishlist.popup.guestMsg',
		defaultMessage: 'Sync your wishlist across devices',
	},
	dismissLabel: {
		id: 'wishlist.popup.dismissLabel',
		defaultMessage: 'Maybe later',
	},
	loginLabel: {
		id: 'wishlist.popup.loginLabel',
		defaultMessage: 'Sign in / Register',
	},
});
